export function getRuleIcon(ruleAction) {
  switch (ruleAction) {
    case 'start':
      return 'rocket';

    case 'stop':
    case 'smart_stop':
    case 'delete':
      return 'blister';

    case 'scaling_up':
      return 'scaling-up';
  }

  return null;
}
